import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

//Custom Components
import ModelTable from "@/ui/Table/ModelTable";

// Types
import { DCRecord, IDataController, DCFieldValue } from "@/@types/lib/dataController"
import StatusDialog from "./LokacijeStatusDialog";
import DialogContext from "@/ui/DialogContext/DialogContext";
import UserDialog from "@/views/Administration/UsersPage/UserDialog";
import { DialogContextType } from "@/@types/ui/DialogContext";

type RadniSastanciLocationtableProps = {
    dc: IDataController;
    records: Array<DCRecord>;
    onRowSelect: (id: number, record: DCRecord) => void;
    selectedProject: DCFieldValue | null;
    rowSelectedCustom?: number;
    refreshRecords?: () => void;
    statusFields?: DCRecord[];
};

let CHANGED_FLAG = false;

function RadniSastanciLocationTable (props: RadniSastanciLocationtableProps) {
    const [rowSelected, setRowSelected] = useState<DCRecord|null>(null);
    const locationField = "id";
    const { t } = useTranslation();
    const { dc, records, onRowSelect,rowSelectedCustom, refreshRecords, statusFields } = props;
    const dialogContext = useContext<DialogContextType>(DialogContext);

    const handleRowSelect = (id: number) => {
        if (rowSelected === null)
            CHANGED_FLAG = true;
            const record = records.find((r:any) => r.id === id);
        if (record !== undefined) {
            const [rLok, rId] = rowSelected === null ? [-1, -1] : [rowSelected[locationField], rowSelected.id];
        if (record.id === rId && record[locationField] === rLok) {
            setRowSelected(null);
            onRowSelect(Number(record[locationField]), record);
        } else if (record.id !== rId && record[locationField] === rLok) {
            setRowSelected(record);
        }else {
            setRowSelected(record);
            onRowSelect(Number(record[locationField]), record);
        }
        } else {
            setRowSelected(null);
        }
    }

    const handleDelete = () => {
        if(refreshRecords !== null && refreshRecords) {
            refreshRecords();
        }
    }

    useEffect(() => {
        if (rowSelected !== null) {
            onRowSelect(Number(rowSelected[locationField]), rowSelected);
        }
    }, []);

    const showStatusDialog = () => {
        dialogContext.showDialog(StatusDialog, {fields: statusFields});
    }

    // RETURN
    // -------------------------------------------------------------------------------------------
    return (
        <ModelTable
            title={t("titles.lokacije")}
            records={records}
            viewName="radni_sastanci"
            dc={dc}
            allowSelection="one"
            allowFilter={true}
            allowExport={true}
            allowEdit={true}
            disableControls={false}
            initialPageSize={25}
            onRowAction={() => {}}
            allowRowAction={() => { return true;}}
            onRowClick={handleRowSelect}
            unselectRow={true}
            rowSelectedCustom={rowSelectedCustom}
            gotoFirstPageOnSelect={false}
            allowInc={false}
            allowInlineEdit={false}
            allowDelete={true}
            allowLegend={true}
            onLegendClick={showStatusDialog}
            onDeleted={handleDelete}
            trackTableState={true}
        >
        </ModelTable>
    )
}

/*
<ModelTable
            title={t("titles.komunalne_obveze")}
            records={records}
            dc={dc}
            allowSelection="many"
            viewName="radni_sastanci"
            allowFilter={true}
            allowExport={true}
            initialPageSize={25}
            onRowAction={() => {}}
            allowRowAction={() => { return true;}}
            >
            <TableButton
                variant="outlined" 
                allow="many"
                selection={[]}
                onClick={(evt, sel) => handleOpenExportDialog(sel)}
                startIcon={<UploadFileIcon />}
            >
                {t("buttons.generate_xml")}
            </TableButton>
        </ModelTable>
*/

export default RadniSastanciLocationTable